/* eslint-disable react/prefer-stateless-function */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { css } from "styled-components";

export interface DividerStyle {}
export const dividerStyle: DividerStyle = {};

const styles = dividerStyle;

class IntDivider extends React.Component<any, any> {
    render() {
        return (
            <StyledWrapper
                css={css`
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                margin-bottom: 45px;
                            `,
                            css`
                                margin-bottom: 45px;
                            `,
                            css`
                                margin: 58px 0;
                            `,
                            css`
                                margin: 58px 0;
                            `,
                            css`
                                margin: 58px 0;
                            `,
                        ])}
                `}
            ></StyledWrapper>
        );
    }
}

const divider: WidgetModule = {
    component: IntDivider,
    definition: {
        group: "Basic",
    },
};

export default divider;
